import React, { useState, useEffect } from "react";
import Topbar from "../topBar";
import Sidebar from "../sideBar";
import Cookies from "universal-cookie";
import {
  getpending,
  rejectBProfile,
  acceptBProfile,
  rejectAllBprofile,
  approveAllBprofile,
  replayToBProfile,
  searchPending
} from "../../actions/businessProfileAction";

import Swal from "sweetalert2/dist/sweetalert2.js";
import { FaImage } from "react-icons/fa";
import {
  FiMessageCircle,
  FiXCircle,
  FiCheckCircle,
  FiEye,
} from "react-icons/fi";
import { Tooltip } from "react-tooltip";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  DialogTitle,
  Grid,
  DialogActions,
  Typography,
  Button,
  Dialog,
  TextField,
} from "@mui/material";
import { APPROVE, FEED, REJECT, VIEW_DET, VIEW_IMG } from "../../constants/url";
import { CONFIRM_TITLE, CONFIRM_TXT_ACC_ALL, CONFIRM_TXT_REJ_ALL, CONFIRM__ACC_ALL_YES_BUTTON, CONFIRM__REJ_ALL_YES_BUTTON, ERR_ALERT_TITLE, ERR_GETTING, ERR_POSTING, SUCC_ALERT_TITLE, SUCC_APPROVE_TEXT, SUCC_APPROVE_TITLE, SUCC_REJECTPRODUCT_TITLE, SUCC_REJECTPRODUCT_TXT } from "../../constants/alertMessage";
import ImageModal from "../../images/imageModal";

const cookies = new Cookies();
const Pending = () => {
  const localRole = JSON.parse(localStorage.getItem("role"))
  const permissions = localRole && localRole.permissions ? localRole.permissions : "All"
  const [values, setValues] = useState({
    name: "",
    error: "",
    pending: [],
    success: false,
    removed: false,
    selectedRows: [],
  });
  const [isSendingFeedback, setIsSendingFeedback] = useState(false);
  const [images, setImages] = useState([]);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [feedId, setFeedId] = useState("");
  const [details, setDetails] = useState({});
  const handleClose = () => {
    setOpen(false);
  };
  const handleClose1 = () => {
    setOpen1(false);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };
  const { pending, selectedRows } = values;
  const agritech_id = cookies.get("agritech_token");
  const [replay, setReplay] = useState("");
  useEffect(() => {
    loadBType();
  }, [])

  const loadBType = () => {
    getpending(agritech_id).then((data) => {
      if (data.error) {
        Swal.fire({
          title: 'Error',
          text: `${data.error}`,
          icon: 'error',
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: 'OK'
        });
      } else {
        setValues({ ...values, pending: data.pending });
      }
    })
      .catch(() => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `${ERR_GETTING}`,
          confirmButtonText: 'OK'
        });
      })
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;

    try {
      const response = await searchPending(searchValue);

      if (response && response.pending) {
        setValues((prevState) => ({
          ...prevState,
          pending: response.pending,
        }));
      } else {
        setValues((prevState) => ({
          ...prevState,
          pending: [],
        }));
      }
    } catch (error) {
      Swal.fire({
        title: `${ERR_ALERT_TITLE}`,
        text: error.message,
        icon: "error",
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonText: "OK",
      });
    }
  };

  const handleChange = (e) => {
    setReplay(e.target.value);
  };
  const handleReplay = (e) => {
    e.preventDefault();
    setIsSendingFeedback(true);
  
    // Fix: Correct parameter order - (id, replay, token)
    replayToBProfile( agritech_id,feedId, replay,)
      .then((data) => {
        if (data.error) {
          setValues({ ...values, error: data.error, loading: false });
          Swal.fire({
            title: 'Error',
            text: data.error,
            icon: 'error',
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
        } else {
          setOpen2(false);
          setReplay("");
          loadBType()
          Swal.fire({
            title: 'Success',
            text: 'Feedback added successfully!',
            icon: 'success',
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: 'Error',
          text: `${ERR_POSTING}`,
          icon: 'error',
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: 'OK'
        });
      }).finally(() => {
        setIsSendingFeedback(false);
      });
  };

  const handleCheckBox = (row) => {
    const { selectedRows } = values;
    const selectedIndex = selectedRows.indexOf(row);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedRows, row);
    } else {
      newSelected = newSelected.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1)
      );
    }

    setValues({ ...values, selectedRows: newSelected });
  };

  function edit(cell, row, extraData, index) {
    console.log(row, "getting data")
    const handleImageClick = () => {

      const imagesData = [row.image1, row.image2, row.image3, row.image4];

      const filteredImagesData = imagesData.filter(
        (image) => image !== undefined && image !== null && image !== ""
      );

      setImages(filteredImagesData);
      setOpen(true);
    };

    const hasImageData = [row.image1, row.image2, row.image3, row.image4].some(
      (image) => image !== undefined && image !== null && image !== ""
    );

    const handleClick = (e) => {
      Swal.fire({
        title: `Approve ${row.company_name}`,
        text: "",
        icon: "success",
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          acceptBProfile(agritech_id, row.id).then((data) => {
            if (data.error) {
              setValues({ ...values, error: data.error, loading: false });
            } else {
              loadBType()
            }
          });
        }
      })
        .catch(() => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: `${ERR_POSTING}`,
            confirmButtonText: 'OK'
          });
        })
    };

    const handleRejectClick = (e) => {
      Swal.fire({
        title: `Reject ${row.company_name}`,
        text: "",
        icon: "error",
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          rejectBProfile(agritech_id, row.id).then((data) => {
            if (data.error) {
              setValues({ ...values, error: data.error, loading: false });
            } else {
              loadBType()
            }
          });
        }
      })
        .catch(() => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: `${ERR_POSTING}`,
            confirmButtonText: 'OK'
          });
        })
    };

    const handlePOP = (e) => {
      setDetails(row);
      setOpen1(true);
    };

    const handleS = (e) => {
      // Perform the state updates only if confirmed
      setFeedId(row.id);
      setOpen2(true);

    };

    return (
      <span>
        {permissions.some(item => item.keyword === "businessProfilesPendingList" && item.isApprove == true) &&
          <>
            <i data-tooltip-id="1" data-tooltip-content={`${APPROVE}`}>
              <FiCheckCircle onClick={handleClick} color="#4fbde9" size="20" />
            </i>
            <Tooltip id="1" />
          </>
        }
        {permissions.some(item => item.keyword === "businessProfilesPendingList" && item.isReject == true) &&
          <>
            <i
              className="ml-1"
              data-tooltip-id="2"
              data-tooltip-content={`${REJECT}`}
            >
              {" "}
              <FiXCircle onClick={handleRejectClick} color="#f36270" size="20" />
            </i>
            <Tooltip id="2" />
          </>
        }

        {permissions.some(item => item.keyword === "businessProfilesPendingList" && item.isFeedback == true) &&
          <>
            {row.replay !== "" ? (
              <i
                className="ml-1"
                data-tooltip-id="3"
                data-tooltip-content={`${FEED}`}
              >
                {" "}
                <FiMessageCircle onClick={handleS} color="#769A0F" size="20" />
                <Tooltip id="3" />
              </i>
            ) : (
              <i
                className="ml-1"
                data-tooltip-id="3"
                style={{ fontStyle: "normal" }}
                data-tooltip-content={`${FEED}`}
              >
                {" "}
                <FiMessageCircle onClick={handleS} color="#f9bc0b" size="20" />
                <Tooltip id="3" />
              </i>
            )}
          </>
        }
        <div
          className="modal fade bs-example-modal-center"
          id={"pop" + row.id}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Feedback
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form onSubmit={handleReplay}>
                <div className="modal-body">
                  <div className="row  justify-content-center text-center">
                    <div className="col-12">
                      <div className="text-left text-dark mb-1"> Message</div>
                      <textarea
                        type="text"
                        className="form-control"
                        value={replay}
                        placeholder="message"
                        name="price"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <i
          className="ml-1"
          data-tooltip-id="4"
          data-tooltip-content={`${VIEW_DET}`}
        >
          {" "}
          <FiEye onClick={handlePOP} color="#9368f3" size="20" />
        </i>
        <Tooltip id="4" />

        {hasImageData && (
          <i
            className="ml-1"
            data-tooltip-id="5"
            data-tooltip-content={`${VIEW_IMG}`}
          >
            {" "}
            <FaImage onClick={handleImageClick} color="green" size="17" />
          </i>
        )}
        <Tooltip id="5" />
      </span>
    );
  }



  function acceptAll(event) {
    event.preventDefault();

    Swal.fire({
      title: `${CONFIRM_TITLE}`,
      text: `${CONFIRM_TXT_ACC_ALL}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `${CONFIRM__ACC_ALL_YES_BUTTON}`
    }).then((result) => {
      if (result.isConfirmed) {

        approveAllBprofile(selectedRows).then(
          (data) => {
            if (data.error) {
              setValues({ ...values, error: data.error, loading: false });
              // Show error message
              Swal.fire({
                title: `${ERR_ALERT_TITLE}`,
                text: data.error,
                icon: 'error',
                confirmButtonText: 'OK'
              });
            } else {

              var mainData = pending;
              var sin = selectedRows;

              for (var i = 0; i < mainData.length; i++) {
                for (var j = 0; j < sin.length; j++) {
                  if (mainData[i].id === sin[j]) {
                    mainData.splice(i, 1);
                  }
                }
              }
              setValues({ ...values, selectedRows: [], data: mainData });

              // Show success message
              Swal.fire({
                title: `${SUCC_APPROVE_TITLE}`,
                text: `${SUCC_APPROVE_TEXT}`,
                icon: 'success',
                confirmButtonText: 'OK'
              });
              loadBType()
            }
          }
        )
      }
    }).catch((error) => {
      console.error('Error while approving :', error);
      // Show error message
      Swal.fire({
        title: `${ERR_ALERT_TITLE}`,
        text: `${ERR_POSTING}`,
        icon: 'error',
        confirmButtonText: 'OK'
      });
    });
  }
  function rejectAll(event) {
    event.preventDefault();

    Swal.fire({
      title: `${CONFIRM_TITLE}`,
      text: `${CONFIRM_TXT_REJ_ALL}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: `${CONFIRM__REJ_ALL_YES_BUTTON}`
    }).then((result) => {
      if (result.isConfirmed) {
        // User confirmed, execute rejectAll logic
        rejectAllBprofile(selectedRows)
          .then((data) => {
            if (data.error) {
              setValues({ ...values, error: data.error, loading: false });
              // Show error message
              Swal.fire({
                title: `${ERR_ALERT_TITLE}`,
                text: data.error,
                icon: 'error',
                confirmButtonText: 'OK'
              });
            } else {
              var mainData = pending;
              var sin = selectedRows;

              for (var i = 0; i < mainData.length; i++) {
                for (var j = 0; j < sin.length; j++) {
                  if (mainData[i].id === sin[j]) {
                    mainData.splice(i, 1);
                  }
                }
              }
              setValues({ ...values, selectedRows: [], data: mainData });

              // Show success message
              Swal.fire({
                title: `${SUCC_REJECTPRODUCT_TITLE}`,
                text: `${SUCC_REJECTPRODUCT_TXT}`,
                icon: 'success',
                confirmButtonText: 'OK'
              });
              loadBType()
            }
          })
          .catch((error) => {
            // Show error message
            Swal.fire({
              title: `${ERR_ALERT_TITLE}`,
              text: `${ERR_POSTING}`,
              icon: 'error',
              confirmButtonText: 'OK'
            });
          });
      }
    });
  }

  return (
    <div id="wrapper">
      <Topbar backgroundColor="#769A0F" />
      <Sidebar type="businessProfiles" />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        {" "}
                        <a href="/dashboard">Dashboard</a>
                      </li>
                      <li className="breadcrumb-item active">Pending List</li>
                    </ol>
                  </div>
                  <h4 className="page-title">Business Profile - Pending List</h4>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card-box">
                  <div style={{ width: "98%" }}>
                    <div className="row mb-3">
                      <div className="box1 ml-2">
                        <div id="toolbar">
                          {permissions.some(item => item.keyword === "businessProfilesPendingList" && item.isApprove == true) &&
                            <form onSubmit={acceptAll}>
                              {selectedRows.length === 0 ? (
                                <button
                                  type="submit"
                                  id="button"
                                  className="btn btn-icon waves-effect waves-light btn-info"
                                  disabled
                                >
                                  {" "}
                                  <i className="fa fa-check"></i> Approve
                                </button>
                              ) : (
                                <button
                                  type="submit"
                                  id="button"
                                  className="btn btn-icon waves-effect waves-light btn-info"
                                >
                                  {" "}
                                  <i className="fa fa-check"></i> Approve
                                </button>
                              )}
                            </form>
                          }
                        </div>
                      </div>

                      <div className="box1 ml-2">
                        <div id="toolbar">
                          {permissions.some(item => item.keyword === "businessProfilesPendingList" && item.isReject == true) &&
                            <form onSubmit={rejectAll}>
                              {selectedRows.length === 0 ? (
                                <button
                                  id="remove"
                                  type="submit"
                                  className="btn btn-icon waves-effect waves-light btn-danger"
                                  disabled
                                >
                                  {" "}
                                  <i className="fa fa-times"></i> Reject
                                </button>
                              ) : (
                                <button
                                  id="remove"
                                  type="submit"
                                  className="btn btn-icon waves-effect waves-light btn-danger"
                                >
                                  {" "}
                                  <i className="fa fa-times"></i> Reject
                                </button>
                              )}
                            </form>
                          }
                        </div>
                      </div>
                      <div style={{ marginLeft: 'auto', width: '200px', marginRight: "40px", position: 'relative' }}>
                        <input
                          type="text"
                          placeholder="Search..."
                          className="form-control"
                          style={{ width: '100%', paddingLeft: '30px', boxSizing: 'border-box' }}
                          onChange={(e) => {
                            handleSearch(e);
                            if (e.target.value.trim() === '') {
                              e.target.nextElementSibling.style.display = 'inline-block';
                            } else {
                              e.target.nextElementSibling.style.display = 'none';
                            }
                          }}
                        />
                        <i
                          className="fas fa-search"
                          style={{
                            position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#aaa'
                          }}
                        ></i>
                      </div>
                    </div>
                    <div style={{ width: "98%" }}>
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell align="left">
                                <Checkbox
                                  style={{ transform: "scale(0.7)" }}
                                  align="left"
                                  checked={
                                    pending.length > 0 &&
                                    selectedRows.length === pending.length
                                  }
                                  onChange={() => {
                                    const newSelected =
                                      pending.length > 0 &&
                                        selectedRows.length !== pending.length
                                        ? pending
                                        : [];
                                    setValues({
                                      ...values,
                                      selectedRows: newSelected,
                                    });
                                  }}
                                />
                              </TableCell>
                              <TableCell align="left">S.No</TableCell>
                              <TableCell align="left">Customer Name</TableCell>
                              <TableCell align="left">
                                Customer Mobile
                              </TableCell>
                              <TableCell align="left">Company Name</TableCell>
                              <TableCell align="left">Business Type</TableCell>
                              {/* <TableCell  align="left">
                              Image
                            </TableCell> */}
                              <TableCell align="left">Actions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {pending.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell align="left">
                                  <Checkbox
                                    style={{ transform: "scale(0.7)" }}
                                    checked={selectedRows.indexOf(row) !== -1}
                                    onChange={() => handleCheckBox(row)}
                                  />
                                </TableCell>

                                <TableCell align="left">{index + 1}</TableCell>
                                <TableCell align="left">{row.name}</TableCell>
                                <TableCell align="left">
                                  {row.customer_mobile_no}
                                </TableCell>
                                <TableCell align="left">
                                  {row.company_name}
                                </TableCell>
                                <TableCell align="left">{row.btype}</TableCell>

                                <TableCell align="left">
                                  {edit(row.cell, row, index)}
                                </TableCell>
                              </TableRow>
                            ))}



                            {/* <Dialog
                              onClose={handleClose}
                              open={open}
                              fullWidth
                              disableEnforceFocus
                              maxWidth="lg"
                            >
                              <DialogTitle
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Typography variant="h6" sx={{ flexGrow: 1 }}>
                                  Images
                                </Typography>
                                <Button
                                  onClick={handleClose}
                                  color="inherit"
                                  sx={{ mr: 0 }}
                                >
                                  <span
                                    style={{ fontSize: "20px" }}
                                    aria-hidden="true"
                                  >
                                    &#128473;
                                  </span>
                                </Button>
                              </DialogTitle>

                              <Grid
                                container

                                alignItems="center"
                                style={{
                                  maxHeight: "80vh", // Ensures the modal content doesn't exceed viewport height
                                  overflowY: "auto",
                                }}
                              >
                                {images.map(
                                  (image, index) =>
                                    image && (
                                      <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={3}
                                        key={index}
                                      >
                                        <img
                                          className="img-responsive"
                                          src={image}
                                          alt="user"
                                          style={{
                                            width: "100rem",
                                            height: "100rem",
                                            maxWidth: "260px",
                                            maxHeight: "350px",
                                            borderRadius: "4px",
                                            marginBottom: "10px",
                                            margin: "8px",
                                          }}
                                        />
                                      </Grid>
                                    )
                                )}
                              </Grid>

                              <DialogActions>
                                <Button
                                  variant="outlined"
                                  color="error"
                                  style={{
                                    marginRight: "3px",
                                    marginBottom: "3px",
                                  }}
                                  onClick={handleClose}
                                >
                                  Close
                                </Button>
                              </DialogActions>
                            </Dialog> */}
                            <ImageModal handleClose={handleClose}
                              open={open}
                              imageSrc={images}>

                            </ImageModal>


                            <Dialog
                              open={open1}
                              onClose={handleClose1}
                              aria-labelledby="details-modal-title"
                              aria-describedby="details-modal-description"
                              style={{
                                maxHeight: "80vh",
                                overflowY: "auto",
                                marginTop: "100px",
                              }}
                              fullWidth
                              disableEnforceFocus
                              maxWidth="lg"
                            >
                              <Grid
                                container
                                justifyContent="center"
                                alignItems="center"
                                className="modal-content"
                              >
                                <Grid item xs={12} className="modal-header">
                                  <h5 id="details-modal-title">Details</h5>
                                  <Button
                                    onClick={handleClose1}
                                    color="inherit"
                                  > <span
                                    style={{ fontSize: "20px" }}
                                    aria-hidden="true"
                                  >
                                      &#128473;
                                    </span>
                                  </Button>
                                </Grid>
                                <Grid item xs={12} className="modal-body">
                                  <Table className="col-12">
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Customer Name
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {details.name}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Customer Mobile
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {details.customer_mobile_no}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Business Type
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {details.btype}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Company Name
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {details.company_name}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Description
                                      </TableCell>
                                      <TableCell
                                        className="text-dark text-right font-weight-normal"
                                      >
                                        {details.description}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Contact Person
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {details.contact_person}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Contact Number
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {details.contact_number}
                                      </TableCell>
                                    </TableRow>

                                    <TableRow>
                                      <TableCell className="text-left">
                                        Location
                                      </TableCell>
                                      <TableCell
                                        className="text-dark text-right font-weight-normal"
                                      >
                                        {details.address}
                                      </TableCell>
                                    </TableRow>
                                    {/* <TableRow>
                                      <TableCell className="text-left">
                                        Charges
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {details.charges}
                                      </TableCell>
                                    </TableRow> */}
                                    {/* <TableRow>
                                      <TableCell className="text-left">
                                        Delivery Available
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {details.deliveryAvailable}
                                      </TableCell>
                                    </TableRow> */}
                                    {/* <TableRow>
                                      <TableCell className="text-left">
                                        Free Delivery
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {details.freeDelivery}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Charges After
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {details.chargesAfter}
                                      </TableCell>
                                    </TableRow> */}
                                  </Table>
                                </Grid>
                                <Grid item xs={12} className="modal-footer">
                                  <Button
                                    onClick={handleClose1}
                                    variant="outlined"
                                    color="error"
                                  >
                                    Close
                                  </Button>
                                </Grid>
                              </Grid>
                            </Dialog>

                            <Dialog
                              open={open2}
                              onClose={handleClose2}
                              maxWidth="lg"
                              fullWidth
                              centered
                              disableEnforceFocus
                            >
                              <div
                                style={{
                                  backgroundColor: "#fff",
                                  padding: "20px",
                                  // minWidth: '500px',
                                  borderRadius: "8px",
                                }}
                              >
                                <h3>Feedback</h3>
                                <form onSubmit={handleReplay}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                      <div className="text-left text-dark mb-1">
                                        Message
                                      </div>
                                      <TextField
                                        type="text"
                                        fullWidth
                                        multiline
                                        rows={4}
                                        variant="outlined"
                                        value={replay}
                                        placeholder="Message"
                                        onChange={handleChange}
                                        required
                                      />
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    container
                                    justifyContent="flex-end"
                                    style={{ marginTop: "20px" }}
                                  >
                                    <Button
                                      variant="outlined"
                                      color="error"
                                      onClick={handleClose2}
                                      style={{ marginRight: "8px" }}
                                      disabled={isSendingFeedback}
                                    >
                                      Close
                                    </Button>
                                    <Button
                                      type="submit"
                                      variant="contained"
                                      disabled={isSendingFeedback}
                                      style={{
                                        backgroundColor: "#769A0F",
                                        color: "#fff",
                                      }}                                     >
                                     {isSendingFeedback ? "Sending..." : "Send"}
                                    </Button>
                                  </Grid>
                                </form>
                              </div>
                            </Dialog>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pending;
